import { render, staticRenderFns } from "./ValidacionPTI.vue?vue&type=template&id=5479b5ba&scoped=true"
import script from "./ValidacionPTI.vue?vue&type=script&lang=js"
export * from "./ValidacionPTI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479b5ba",
  null
  
)

export default component.exports